import React from "react";
import { CalendarRange, CalendarClock, CalendarCheck, Plane, Crown, Building2, HeartHandshake, Key } from "lucide-react";

const services = [
  { icon: CalendarRange, t: "Daily Rentals", d: "Short-term rentals from $39/day. Instant confirmation." },
  { icon: CalendarClock, t: "Weekly Rentals", d: "Save up to 15% on 7+ day reservations." },
  { icon: CalendarCheck, t: "Monthly Rentals", d: "Flexible 30-day plans with roadside assistance included." },
  { icon: Plane, t: "Airport Transfers", d: "Chauffeured pickups from all major DFW-area airports." },
  { icon: Crown, t: "Chauffeur Services", d: "Trained, uniformed drivers for executives and events." },
  { icon: Building2, t: "Corporate Rentals", d: "Custom fleets, priority billing and dedicated account managers." },
  { icon: HeartHandshake, t: "Wedding & Event Rentals", d: "Turn moments into memories with our luxury classics." },
  { icon: Key, t: "Long-Term Leasing", d: "6-, 12- and 24-month lease programs at concierge rates." },
];

export default function Services() {
  return (
    <div className="bg-[#040B16] text-white">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <div className="eyebrow mb-3">What we offer</div>
        <h1 className="font-display font-extrabold text-5xl sm:text-6xl tracking-tighter mb-6">Services designed around your journey.</h1>
        <p className="text-white/70 max-w-2xl mb-14">From daily rentals to bespoke corporate mobility, our services cover every scenario — with the same standard of precision.</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => (
            <div key={s.t} className="card-marketing p-8" data-testid={`service-${s.t.toLowerCase().replace(/\s+/g, "-")}`}>
              <s.icon className="w-8 h-8 text-[#D4AF37] mb-4" />
              <div className="font-display text-xl font-bold tracking-tight">{s.t}</div>
              <p className="text-sm text-white/60 mt-2 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
